import { render } from "./SectionBorderedWrapper.vue?vue&type=template&id=8bb4b0e8"
const script = {}

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__